import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  rolesList: [],
  roleById: {},
  permissionList: [],
  loading: {
    create: false,
    read: false,
    update: false,
    delete: false,
    getById: false,
    getPermissionList: false,
  },
  error: false,
  errorMessage: "",
};

const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    getRolesList(state, action) {
      state.rolesList = action.payload;
      state.loading.read  = false;
      state.error = false;
    },
    roleByIdData(state, action) {
      state.roleById = action.payload;
      state.loading.getById = false;
      state.error = false;
    },
    permissionListData(state, action) {
      state.permissionList = action.payload;
      state.loading.getPermissionList = false;
      state.error = false;
    },
    errorMessages(state, action) {
      state.error = true;
      state.errorMessage = action.payload;
      state.loading = false;
    },
    loadingData(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
  },
});

export const {
  getRolesList,
  roleByIdData,
  errorMessages,
  permissionListData,
  loadingData,
  hideErrorMessage,
} = roleSlice.actions;

export default roleSlice.reducer;
